<template>
  <card-block>
    <spinner-block v-model="dataProgress">
      <template v-if="data">
        <card-header>
          <router-link :to="{name: 'subscription.list'}">Подписка</router-link><!--
                    -->:
          <span class="text-secondary">#{{ data.id }}</span>
          {{ data.name }}
        </card-header>
        <tab-list>
          <tab-link to="subscription.detail">Основные данные</tab-link>
          <tab-link to="subscription.subusers">Привязанные пользователи</tab-link>
          <tab-link to="subscription.payments" v-if="can('module.payment.view')">Платежи</tab-link>
          <tab-link to="subscription.client-calls" v-if="can('module.client_call.view')">Вызовы</tab-link>
          <tab-link to="subscription.promocode-use" v-if="can('module.promocode.view')">Промокоды</tab-link>
        </tab-list>
        <card-body>
          <router-view :key="id" :data="data" @change="getData"></router-view>
        </card-body>
      </template>
    </spinner-block>
  </card-block>
</template>

<script>
export default {
  data: function () {
    return {
      data: null,
      dataProgress: true,
    }
  },
  props: {},
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (this.id) {
        axiosGetValue('/api/admin/subscription/get', {id: this.id}, e => this.data = e, e => this.dataProgress = e)
      }
    },
  },
}
</script>
